import React, { useState } from 'react';
import { useHistory } from "react-router-dom";


export default function PageNotFound(){

    let history = useHistory();
    const [buttonColor, setButtonColor] = useState('#0D6EFD');

    return(
        <div className="container" style={{ marginTop: 20 }}>
            <div style={{ display:'flex', flexDirection:'column', alignItems:'center' }}>
                <img width="60%" src="https://cdn.pixabay.com/photo/2016/04/24/22/30/monitor-1350918_1280.png" alt="Page Not Found"/>
                <div style={{ marginTop:'2vh', display:'flex', flexDirection:'row', borderWidth:'1px', borderColor:'red' }}>
                    <div style={{ color:'red', fontSize:'2vw', textAlign:'center', lineHeight:'5vh', marginRight:'2vh' }}>
                        <span style={{ display: 'inline-block', verticalAlign:'middle', lineHeight:'normal' }}>Please verify that you have the right link</span>
                    </div>
                    <div className="custom-button" 
                        style={{ backgroundColor: buttonColor, padding:'0.5vh', fontSize:'2vw', }} 
                        onMouseOut={() => setButtonColor('#0D6EFD')}
                        onMouseOver={() => setButtonColor('#0d5dfd')}
                        onMouseDown={() => setButtonColor('#5d0dfd')}
                        onMouseUp={() => {
                                setButtonColor('#0d5dfd');
                                history.goBack()
                                }}
                        >Back
                    </div>
                </div>
                
            </div>
        </div>
    );
}
